import { render, staticRenderFns } from "./orderDialog.vue?vue&type=template&id=55cea1f9&scoped=true"
import script from "./orderDialog.vue?vue&type=script&lang=js"
export * from "./orderDialog.vue?vue&type=script&lang=js"
import style0 from "./orderDialog.vue?vue&type=style&index=0&id=55cea1f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cea1f9",
  null
  
)

export default component.exports